import styled from "styled-components";

export const ProfileTabContainer = styled.div`
  padding: 0 1rem;
  width: 100%;
  display: flex;
  position: relative;

  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;

  scrollbar-width: none;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;
